// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"styles_linkContainer__1Fcb4","box":"styles_box__2KL07","showmore":"styles_showmore__2nXkX"};